/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesFriendsGetFriendsRequest interface.
 */
export function instanceOfFxIdWebFeaturesFriendsGetFriendsRequest(value) {
    if (!('FriendsIds' in value) || value['FriendsIds'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesFriendsGetFriendsRequestFromJSON(json) {
    return FxIdWebFeaturesFriendsGetFriendsRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsGetFriendsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'FriendsIds': json['FriendsIds'],
    };
}
export function FxIdWebFeaturesFriendsGetFriendsRequestToJSON(json) {
    return FxIdWebFeaturesFriendsGetFriendsRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesFriendsGetFriendsRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'FriendsIds': value['FriendsIds'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesFriendsGetFriendsRequest.js.map